import type { Entity } from 'models';
import { useTranslation } from 'react-i18next';
import { Col, Row, Text } from 'ui';

type P = {
  entities: Entity[];
  infoMessage?: string;
  showInfoMessage?: boolean;
};

const ConsentsDescription = ({ entities, infoMessage, showInfoMessage = true }: P) => {
  const { t } = useTranslation();
  const isEntitiesInfoVisible = entities.length > 0;

  if (!isEntitiesInfoVisible && !showInfoMessage) {
    return null;
  }

  return (
    <Row className="consents-form__description">
      <Col>
        {isEntitiesInfoVisible ? (
          <>
            <Text>You’re missing consents from following communities:</Text>
            <ul>
              {entities.slice(0, entities.length === 3 ? 3 : 2).map((entity) => (
                <li key={entity.id}>
                  <Text>{entity.name}</Text>
                </li>
              ))}
              {entities.length > 3 ? (
                <li>
                  <Text>{t('more_communities_count', { count: entities.length - 2 })}</Text>
                </li>
              ) : null}
            </ul>
          </>
        ) : null}
        {showInfoMessage ? (
          <Text>
            {infoMessage ??
              'To use the application, you must agree with policies. Without consent, it will not be possible to use the application.'}
          </Text>
        ) : null}
      </Col>
    </Row>
  );
};

export default ConsentsDescription;
